import React from 'react';
import CompanyPageTab from './CompanyPageTab';
import SharedNav from './SharedNav';

function CompanyPagesAdmin({ user, onLogout }) {
  return (
    <div>
      <SharedNav user={user} onLogout={onLogout} />
      <div style={{ paddingTop: 20 }}>
        <CompanyPageTab user={user} />
      </div>
    </div>
  );
}

export default CompanyPagesAdmin;
